export default {"src":"/_next/static/media/science_selected.fffd4972.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};